export default "__VITE_ASSET__ixQJEzfU__"